export enum PaymentLinkStatus {
  ACTIVE = 'active',
  USED = 'used',
  EXPIRED = 'expired',
  REJECTED = 'rejected'
}

export interface PaymentLink {
  id: string;
  userId: string;
	accountNumber: string;
  name: string;
  description?: string;
  amount: number;
  currency: string;
  token: string;
  status: PaymentLinkStatus;
  expirationDate: Date;
  createdAt: string;
  singleUse: boolean;
  updatedAt: string;
  usedDate?: string;
  userInfo?: {
    email: string;
    fullName: string;
  };
}

export interface PaymentLinkListResponse {
  items: PaymentLink[];
  total: number;
}

export interface SuccessResponse {
  success: boolean;
  message: string;
}
